import React, { useRef, useState } from 'react'
import i18n from 'i18next'
import { Button, Divider, Form, Input, Select, Space, Typography } from 'antd'
import { rpc } from '../api/requests'
import { useAuth } from '../context/AuthProvider'
import { getAutosearchUrl } from '../api/consts'
import { CloseOutlined, RightOutlined } from '@ant-design/icons'
import { InfoModal } from './common'

const AutoSearch = ({
  name,
  scope,
  label,
  info,
  placeholder,
  addNonExistant,
  newItemName,
  newItemLabel,
  newItemButtonLabel,
  newItemPlaceholder,
}) => {
  const [options, setOptions] = useState([])
  const { token, apiHost } = useAuth()
  const selectRef = useRef()
  const [showAddNewItem, setShowAddNewItem] = useState(false)

  const onSearch = (searchText) => {
    if (!searchText) return

    getSearchOptions(searchText, (response) => {
      const optionsList = response.map((obj) => {
        return {
          label:
            obj.str ||
            (i18n.resolvedLanguage === 'de' ? obj.name : obj.name_en),
          value: obj.GUID,
        }
      }, {})
      setOptions(optionsList)
    })
  }

  const getSearchOptions = async (term, onSuccess) => {
    const data = {
      method: 'search',
      limit: 30,
      scope: scope || name,
      q: term,
    }
    const result = await rpc(getAutosearchUrl(apiHost), token, data)
    if (result['ERROR']) {
      displayError(result['ERROR']['ID'])
    } else {
      console.log('Success:', result)
      onSuccess(result['object_list'])
    }
  }

  return (
    <>
      <Form.Item label={label} className={showAddNewItem ? 'disabled' : ''}>
        <Form.Item name={name} noStyle>
          <Select
            className="autosearch"
            showSearch
            disabled={showAddNewItem}
            notFoundContent={null}
            filterOption={false}
            ref={selectRef}
            options={options}
            onSearch={onSearch}
            placeholder={placeholder}
            dropdownRender={(menu) => (
              <>
                {menu}
                {addNonExistant && (
                  <>
                    <Divider style={{ margin: '8px 0 0' }} />
                    <Space align="start">
                      <Button
                        type="text"
                        block
                        className="add-new-item"
                        icon={<RightOutlined />}
                        onClick={() => {
                          setShowAddNewItem(true)
                        }}
                      >
                        {newItemButtonLabel}
                      </Button>
                    </Space>
                  </>
                )}
              </>
            )}
          />
        </Form.Item>
        <span className="input-info">
          <InfoModal>{info}</InfoModal>
        </span>
      </Form.Item>
      {showAddNewItem && (
        <Form.Item label={newItemLabel}>
          <Form.Item name={newItemName} noStyle>
            <Input placeholder={newItemPlaceholder} hidden={!showAddNewItem} />
          </Form.Item>
          <span className="remove">
            <Typography.Paragraph className="mb-0">
              <CloseOutlined onClick={() => setShowAddNewItem(false)} />
            </Typography.Paragraph>
          </span>
        </Form.Item>
      )}
    </>
  )
}

export default AutoSearch
